import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=2038d140&scoped=true&"
import script from "./ProfileImage.vue?vue&type=script&lang=ts&"
export * from "./ProfileImage.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileImage.vue?vue&type=style&index=0&id=2038d140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038d140",
  null
  
)

export default component.exports